import type { DropTier } from './types';

export interface BossDef {
  id: string;
  nameKey: string;
  baseEnemyId: string;      // reuses existing EnemyDef for sprite + base stats
  hpMult: number;
  atkMult: number;
  defMult: number;
  unlockAfterTier: number;  // player must have cleared this vault tier at least once
  /** Cooldown in seconds. Doubles per boss tier: 30 → 60 → 120 → 240 → 480 */
  cooldownSec: number;
  exclusiveItemIds: string[];
  guaranteedDrops: number;
  bonusDropTier: DropTier;
}

export const WORLD_BOSSES: BossDef[] = [
  // Boss → Legendary mapping after 2026-05 catalog cleanup. One legendary per boss
  // (down from up-to-3); world_boss_omega has no exclusive yet — reserve slot for a
  // future second set. Bosses still drop their bonusDropTier loot from the rarity pool.
  {
    id: 'world_boss_alpha',
    nameKey: 'boss.alpha',
    baseEnemyId: 'patrol_drone',
    hpMult: 3, atkMult: 2, defMult: 1.5,
    unlockAfterTier: 1, cooldownSec: 30,
    exclusiveItemIds: ['legendary_sword'],
    guaranteedDrops: 2,
    bonusDropTier: 'rare',
  },
  {
    id: 'world_boss_sigma',
    nameKey: 'boss.sigma',
    baseEnemyId: 'reaver_bot',
    hpMult: 2.5, atkMult: 2, defMult: 2,
    unlockAfterTier: 2, cooldownSec: 60,
    exclusiveItemIds: ['legendary_staff'],
    guaranteedDrops: 2,
    bonusDropTier: 'epic',
  },
  {
    id: 'world_boss_tau',
    nameKey: 'boss.tau',
    baseEnemyId: 'elite_sentinel',
    hpMult: 2.5, atkMult: 2.5, defMult: 2,
    unlockAfterTier: 3, cooldownSec: 120,
    exclusiveItemIds: ['legendary_lightning'],
    guaranteedDrops: 2,
    bonusDropTier: 'epic',
  },
  {
    id: 'world_boss_phi',
    nameKey: 'boss.phi',
    baseEnemyId: 'reactor_titan',
    hpMult: 2, atkMult: 2, defMult: 2.5,
    unlockAfterTier: 4, cooldownSec: 240,
    exclusiveItemIds: ['legendary_amulet'],
    guaranteedDrops: 3,
    bonusDropTier: 'legendary',
  },
  {
    id: 'world_boss_omega',
    nameKey: 'boss.omega',
    baseEnemyId: 'omega_herald',
    hpMult: 2, atkMult: 1.8, defMult: 2,
    unlockAfterTier: 5, cooldownSec: 480,
    // No exclusive — drops only from generic legendary pool.
    // Reserved for a future second set / Mythic-tier item.
    exclusiveItemIds: [],
    guaranteedDrops: 3,
    bonusDropTier: 'legendary',
  },
];

export function getBoss(id: string): BossDef | undefined {
  return WORLD_BOSSES.find((b) => b.id === id);
}
